'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

exports.default = init;

var _helpers = require('./_helpers');

var _uuid = require('uuid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var listeners = (0, _create2.default)(_helpers.Listeners);
  // Buttons for Digital and Physical
  var cardTypeButtons = context.getElements('.prd-GiftCard_TypeButton');

  // Input to store the selected card type
  var cardTypeInput = context.getElement('.prd-GiftCard_TypeInput');

  // Card value variants
  var cardVariants = context.getElements('.prd-GiftCard_Variant');

  // Text inputs unique to the physical card type
  var cardTypePhysicalInputs = [context.getElement('[name="properties[Address Line 1]"]'), context.getElement('[name="properties[Address Line 2]"]'), context.getElement('[name="properties[City]"]'), context.getElement('[name="properties[Postcode]"]'), context.getElement('[name="properties[Country]"]')];

  // Submit and pay button
  var cardSubmit = context.getElement('.prd-GiftCard_Pay');

  // JSON parsed product object
  var productObject = JSON.parse(context.getElement('[data-product-json]').innerText);

  // Form for checkout submission
  var checkoutForm = context.getElement('.prd-GiftCard_CheckoutForm');

  // Form for cart submission
  var cartForm = context.getElement('.prd-GiftCard_CartForm');

  // Message limit
  var personalMessageInput = context.getElement('[name="properties[Personalised Message]"]');
  var personalMessageLimitCharacters = context.getElement('.prd-GiftCard_MessageLimitCharacters');
  var messageLimit = 250;

  // Entry point
  var construct = function construct() {
    // Bind click on type buttons
    cardTypeButtons.forEach(function (el) {
      listeners.add(el, 'click', cardTypeClick);
    });

    // Bind click on variants
    cardVariants.forEach(function (el) {
      listeners.add(el, 'click', cardVariantClick);
    });

    // Bind click on submit to pay button
    listeners.add(cardSubmit, 'click', cardSubmitClick);

    listeners.add(personalMessageInput, 'keydown', messageChange);
    listeners.add(personalMessageInput, 'keyup', messageChange);
  };

  // Function called on card type click
  var cardTypeClick = function cardTypeClick(event) {
    // Get the value from the button we clicked and set the value of the input to use later
    cardTypeInput.value = event.currentTarget.value;

    // For ever button, toggle the active class matching the current clicked button
    cardTypeButtons.forEach(function (button) {
      button.classList.toggle('prd-GiftCard_TypeButton-active', button === event.currentTarget);
    });

    // Toggle visibility of inputs based on type selected
    cardTypePhysicalInputs.forEach(function (input) {
      input.classList.toggle('prd-GiftCard_DetailsInput-hidden', event.currentTarget.value === 'Digital');
    });
  };

  // Function called on variant clicked
  var cardVariantClick = function cardVariantClick(event) {
    // Toggle active class on the item we click
    cardVariants.forEach(function (variant) {
      variant.classList.toggle('prd-GiftCard_Variant-active', variant === event.currentTarget);
    });

    // Set the variant option input to help us find the variant ID later
    var optionIndex = event.currentTarget.dataset.index;
    var optionValue = event.currentTarget.dataset.value;
    context.getElement('[data-option][data-index="' + optionIndex + '"]').value = optionValue;
  };

  var messageChange = function messageChange(event) {
    personalMessageLimitCharacters.innerText = messageLimit - personalMessageInput.value.length;
  };

  // Function called when the submit to pay button is clicked
  var cardSubmitClick = function cardSubmitClick(event) {
    // Prevent browser default event
    event.preventDefault();

    // Create object of variant options
    var options = {
      option1: null,
      option2: null,
      option3: null

      // Loop option inputs and fill our options object
    };context.getElements('[data-option]').forEach(function (option) {
      options[option.dataset.index] = option.value;
    });

    // Filter the current product variants to match the options we've selected
    var filteredVariants = productObject.variants.filter(function (variant) {
      return variant.option1 === options.option1 && variant.option2 === options.option2 && variant.option3 === options.option3;
    });

    // Don't do anything if no variant is found, something has gone wrong
    if (filteredVariants.length === 0) return;

    // The chosen variant should be the first one
    var chosenVariant = filteredVariants[0];

    // We'll generate a UUID that we can attach to both items. This way we can keep them tied together if we want to remove the gift card
    var uuid = (0, _uuid.v4)();

    // Build a request body, initially populating it with the data for the current product
    var requestBody = {
      items: [{
        quantity: 1,
        id: chosenVariant.id,
        properties: {
          Type: cardTypeInput.value,
          'Personalised Message': context.getElement('[name="properties[Personalised Message]"]').value,
          'First Name': context.getElement('[name="properties[First Name]"]').value,
          'Last Name': context.getElement('[name="properties[Last Name]"]').value,
          _id: uuid
        }
      }]
    };

    var digital = true;

    // If we have a physical product, we need to add a dummy physical item too which triggers shipping details
    if (cardTypeInput.value === 'Physical') {
      digital = false;

      // Add Physical properties
      requestBody.items[0] = (0, _assign2.default)({}, requestBody.items[0], {
        'Address Line 1': context.getElement('[name="properties[Address Line 1]"]').value,
        'Address Line 2': context.getElement('[name="properties[Address Line 2]"]').value,
        City: context.getElement('[name="properties[City]"]').value,
        Postcode: context.getElement('[name="properties[Postcode]"]').value,
        Country: context.getElement('[name="properties[Country]"]').value

        // Push dummy item to body
      });requestBody.items.push({
        quantity: 1,
        id: 33065618538605,
        properties: {
          _id: uuid
        }
      });

      // Pre-fill checkout
      context.getElement('[name="checkout[shipping_address][first_name]"]').value = context.getElement('[name="properties[First Name]"]').value;
      context.getElement('[name="checkout[shipping_address][last_name]"]').value = context.getElement('[name="properties[Last Name]"]').value;
      context.getElement('[name="checkout[shipping_address][address1]"]').value = context.getElement('[name="properties[Address Line 1]"]').value;
      context.getElement('[name="checkout[shipping_address][address2]"]').value = context.getElement('[name="properties[Address Line 2]"]').value;
      context.getElement('[name="checkout[shipping_address][city]"]').value = context.getElement('[name="properties[City]"]').value;
      context.getElement('[name="checkout[shipping_address][zip]"]').value = context.getElement('[name="properties[Postcode]"]').value;
      context.getElement('[name="checkout[shipping_address][country]"]').value = context.getElement('[name="properties[Country]"]').value;
    }

    // Add our items to card and manually trigger a checkout submission
    fetch('/cart/add.js', {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      },
      method: 'post',
      body: (0, _stringify2.default)(requestBody)
    }).then(function (response) {
      return response.json();
    }).then(function (data) {
      if (digital) {
        cartForm.submit();
      } else {
        checkoutForm.submit();
      }
    });
  };

  // Run entry point
  construct();
}